import { render, staticRenderFns } from "./TeamAdminCreate.vue?vue&type=template&id=0ec5e4fa&"
import script from "./TeamAdminCreate.vue?vue&type=script&lang=ts&"
export * from "./TeamAdminCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports